import { GetTeamsResponse } from '@thera-hr/api-sdk/api/resources/api/resources/thera/resources/company';
import useSWR from 'swr';
import { useMemo } from 'react';

import { useUser } from 'context/user';
import { useCompany } from 'context/company';
import { globalFetcherSettings } from 'lib/constants';
import { useTheraFernClient } from './useFern';

export const useTeamsSWR = () => {
  const { isLoading: isUserLoading } = useUser();
  const { theraFernApi } = useTheraFernClient();
  const { company, isLoading: isCompanyLoading } = useCompany();
  const companyId = company?.companyID;
  const { roleType } = useUser();
  const isManager = roleType === 'manager';

  const getTeamsFetcher = async (): Promise<GetTeamsResponse> => {
    const response = await theraFernApi.thera.company.companyApi.getTeams(companyId);
    return response;
  };

  const {
    data,
    error,
    mutate,
    isLoading: isSWRLoading,
  } = useSWR(() => (companyId && isManager ? ['getTeamsFetcher', companyId] : false), getTeamsFetcher, {
    ...globalFetcherSettings,
    onErrorRetry: (error) => {
      if (error.status === 404) return;
    },
  });

  const isLoading = isUserLoading || isCompanyLoading || isSWRLoading;

  const sortedTeams = useMemo(() => {
    if (!data?.teams) return {};
    return Object.fromEntries(
      Object.entries(data.teams).sort(([, a], [, b]) => (a?.name ?? '').localeCompare(b?.name ?? '')),
    );
  }, [data?.teams]);

  return {
    teams: sortedTeams,
    mutate,
    isPending: isLoading,
    error,
  };
};
